import React, { useState, useContext, useEffect } from "react";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import { OtpInput } from "reactjs-otp-input";
// import React, { Component } from 'react';
import Countdown from "react-countdown";
import Cookies from "js-cookie";
import { Context } from "../../../utils/context";
import LoginLottie from "./LoginLottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { getData } from "../../../utils/api";
const LoginPage = () => {
  const { postData, signin, setSignin, usertype, setUsertype, IMG_URL } =
    useContext(Context);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [showErrorModal, setShowErrorModal] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const validateForm = () => {
    let errors = {};

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

    if (!formData.password.trim()) {
      errors.password = "Password is required";
    }

    return errors;
  };
  const [emailNoError, setEmailNoError] = useState("");
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    // if (!verifyStatusEmail) {
    //   setEmailNoError("Please verify your email before submitting.");
    //   // setError("email", {
    //   //   type: "manual",
    //   //   message: "Please verify your email before submitting.",
    //   // });
    //   return;
    // }
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await postData("/common/auth/admin-login", formData);

        if (response.success) {
          setSignin(response.success);
          setUsertype(response?.data?.role);

          Cookies.set("urban_prime_security", response.data?.token, {
            expires: 365,
          });

          if (response?.data?.role === "demo") {
            navigate("/demo");
          } else if (response?.data?.role?.length) {
            navigate("/advanceDashboard");
          }

          // else if (response?.data?.role === "Data Entry Head") {
          //   navigate("/data-entry");
          // } else {
          //   navigate(`/generatedbill`);
          // }
        } else {
          setShowErrorModal(response);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const successStyle = {
    color: "green",
    marginLeft: "5px",
  };

  const [otp, setOtp] = useState("");
  // const [otpEmail, setEmailOtp] = useState("");
  const [appSetup, setAppSetup] = useState({});
  const GetAppSetup = async () => {
    const response = await getData(`/common/masters/app-setup`);
    if (response?.success) {
      setAppSetup(response?.data);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  const handleGetOtp = () => {
    // setShowOtp(true);
    setEmailNoError("");
    sendOtpEmail();
  };

  const [showOtp, setShowOtp] = useState(false);
  const sendOtpEmail = async () => {
    try {
      const response = await postData(`/common/auth/send-otp`, {
        email: formData.email,
      });

      if (response?.success) {
        // handleNext();
        setShowOtp(true);
      } else {
        setEmailNoError(response.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [otpError, setOtpError] = useState("");
  const [verifyStatusEmail, setVerifyStatusEmail] = useState(false);
  const verifyEmailOtp = async () => {
    if (!otp || otp.length < 4) {
      setOtpError("Provide Four Digit OTP");
      return;
    }
    try {
      const response = await postData(`/common/auth//verify-otp`, {
        email: formData.email,
        otp: otp,
      });
      console.log(response?.errors, "response response");

      if (response?.success) {
        setVerifyStatusEmail(true);
        setShowOtp(false);
        // handleNext(); // Proceed to the next step
        setOtpError("");
        setEmailNoError("");
      } else {
        // Set the error message received from the server
        setEmailNoError(response?.errors || "An error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An unexpected error occurred. Please try again."); // Generic error message
    }
  };
  // const sendOtp = async (e) => {
  //   e.preventDefault();

  //   const validationErrors = validateForm();

  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //   } else {
  //     try {
  //       const response = await postData("/common/auth/admin-login", formData);

  //       if (response.success) {
  //         setSignin(response.success);
  //         setUsertype(response?.data?.role);

  //         Cookies.set("urban_prime_security", response.data?.token, {
  //           expires: 365,
  //         });

  //         if (response?.data?.role === "demo") {
  //           navigate("/demo");
  //         } else if (response?.data?.role?.length) {
  //           navigate("/advanceDashboard");
  //         }

  //         // else if (response?.data?.role === "Data Entry Head") {
  //         //   navigate("/data-entry");
  //         // } else {
  //         //   navigate(`/generatedbill`);
  //         // }
  //       } else {
  //         setShowErrorModal(response);
  //       }
  //     } catch (error) {
  //       console.error("Error submitting form:", error);
  //     }
  //   }
  // };
  return (
    <>
      <section className="Login">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-xl-6 col-lg-5 col-md-4 col-sm-6">
              <LoginLottie IMG_URL={IMG_URL} appSetup={appSetup} />
              {/* <img
                className="logo ms-2"
                // src={process.env.PUBLIC_URL + "/netpurtilogo.png"}
                src={IMG_URL + appSetup?.logo}
              /> */}
            </div>
            <div className="col-xl-6 col-lg-7 col-md-8 col-sm-6">
              <div className="card text-center login-card">
                <div className="text-holder-login">
                  <h2 className="text-start">Login</h2>
                  <p className="text-start mt-4">
                    Hey, Enter your details to get sign in to your account
                  </p>

                  {showErrorModal?.success ? (
                    <></>
                  ) : (
                    <>
                      <span style={errorStyle}>{showErrorModal?.errors}</span>
                    </>
                  )}
                  <form onSubmit={handleSubmit} role="form">
                    <div className="form_group">
                      <div class=" text-start">
                        <label
                          for="exampleInputEmail1"
                          className="email_txt form-label"
                        >
                          Email ID
                        </label>
                      </div>

                      <div className="mb-3 form-control-email">
                        <input
                          type="email"
                          className="form-control inputForm"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Enter Email"
                          name="email"
                          value={formData.email}
                          onChange={(e) => {
                            handleChange(e);
                            errors.email = "";
                          }}
                        />
                      </div>
                      {/* {!verifyStatusEmail ? (
                        <p className="sendotpp" onClick={handleGetOtp}>
                          Send Otp
                        </p>
                      ) : (
                        <p className="sendotpp">Verified</p>
                      )} */}

                      {showOtp && (
                        <div className="otp_group">
                          <div className="otpsec">
                            <OtpInput
                              value={otp}
                              onChange={setOtp}
                              numInputs={4}
                              separator={<span>-</span>}
                            />
                          </div>
                          {/* <div className="timer_div">
                            <Countdown date={Date.now() + 100000} />
                          </div> */}
                          <div className="verifydiv">
                            <button
                              className="verifybtn"
                              onClick={(e) => {
                                e.preventDefault();
                                verifyEmailOtp();
                              }}
                            >
                              Verify Otp
                            </button>
                          </div>
                        </div>
                      )}

                      {otpError ? (
                        <></>
                      ) : (
                        <>
                          <span style={errorStyle}>{otpError}</span>
                        </>
                      )}

                      {errors.email && (
                        <span style={errorStyle}>{errors.email}</span>
                      )}
                      {emailNoError && (
                        <span className="text-danger">{emailNoError}</span>
                      )}
                    </div>

                    {/* <div class=" text-start">
                      <label
                        for="exampleInputEmail1"
                        class="email_txt form-label"
                      >
                        Password
                      </label>
                    </div> */}

                    <div className="form-control-email input-group password_section">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control inputForm"
                        placeholder="Password"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        name="password"
                        value={formData.password}
                        onChange={(e) => {
                          handleChange(e);
                          errors.password = "";
                        }}
                      />

                      <FontAwesomeIcon
                        icon={showPassword ? faEye : faEyeSlash}
                        className="formPasword"
                        onClick={togglePasswordVisibility}
                      />
                    </div>
                    {errors.password && (
                      <span style={errorStyle}>{errors.password}</span>
                    )}

                    <input
                      className="form-control dummy_input"
                      placeholder="dummy"
                    />

                    <Link to="/">
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className="btn sign-in-button text-center"
                      >
                        Login
                      </button>
                    </Link>
                    {/* <Link to="/forget-password" className="text-dark ">
                      <p className="py-3 mb-0">Forget Password</p>

                    </Link> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginPage;
